import { api } from '@/api/client';
import { SchemaForm, SchemaFormValues } from '@/features/SchemaForm';
import { InquiryFormTemplate } from '@/features/SchemaForm/templates/InquiryFormTemplate';
import { useInquiryContactDefaults } from '@/hooks/useInquiryContactDefaults';
import { inquiryBuyPropertySchema } from '@mr-website/schemas';

const DiscussBuyingForm = () => {
  const { defaultValuesCallback } = useInquiryContactDefaults();

  const handleSubmit = async (values: SchemaFormValues) => {
    await api.post('/inquiry/buy-property', values);
  };

  return (
    <SchemaForm
      zodSchema={inquiryBuyPropertySchema}
      defaultValuesCallback={defaultValuesCallback}
      template={
        <InquiryFormTemplate
          title="To Discuss Buying Further"
          description="All fields are required. We will contact you within 24 hours to discuss your buying interests."
          successMessage="A Real Estate Advisor will be in touch with you shortly."
        />
      }
      variant="stacked"
      onSubmit={handleSubmit}
      enableTurnstile
    />
  );
};

export { DiscussBuyingForm };
